import React, { useState } from 'react';
import {
    Box,
    Button,
    TextField,
    Typography,
    InputAdornment,
    IconButton,
    Paper,
    Snackbar,
    Alert
} from '@mui/material';
import { useAuth } from "../context/AuthContext";
import { login as loginAPI } from "../services/index";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate } from 'react-router-dom';
import CircularProgress from "@mui/material/CircularProgress";
export default function LoginPage({ onLoginSuccess = () => { } }) {
    const [showPassword, setShowPassword] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
    const { login } = useAuth();
   
    const [form, setForm] = useState({ email: "", password: "" });

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
 
    const navigate = useNavigate();
    const handleSnackbarClose = () => {
        setSnackbar((prev) => ({ ...prev, open: false }));
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleLogin = async () => {
        try {
            setIsLoading(true)
            const response = await loginAPI({
                email: form.email,
                password: form.password,
            });
            if (response.status === 200) {
                const logindata = response.data;
                const { token, user_type, data } = response.data;
                localStorage.setItem("token", token);
                login(user_type, logindata);
                const Id = logindata.id;
                setSnackbar({
                    open: true,
                    message: "Login successful!",
                    severity: "success",
                });
                onLoginSuccess(true, Id);
                navigate("/home");
            }
        } catch (error) {
            setIsLoading(false)
            console.error("Login error:", error?.response?.data?.message);
            setSnackbar({
                open: true,
                message: error?.response?.data?.message || "Login failed. Please try again.",
                severity: "error",
            });
            onLoginSuccess(false);
        }
    };

    return (
        <>
            <Box
                sx={{
                    minHeight: '100vh',
                    background: 'linear-gradient(to right, #0f9ba1, #8ee3a8)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    p: 2,
                }}
            >
                <Paper
                    elevation={5}
                    sx={{
                        p: 5,
                        width: '100%',
                        maxWidth: 450,
                        borderRadius: 2,
                        textAlign: 'center',
                    }}
                >
                    <Box sx={{ mb: 4 }}>
                        <Typography
                            variant="h4"
                            sx={{
                                background: 'linear-gradient(to right, #0f9ba1, #8ee3a8)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                fontWeight: 600,
                            }}
                        >
                            Sign-in To GETMentor
                        </Typography>
                    </Box>
                    <Typography align="left" mb={1} fontSize={14}>
                        <span style={{ color: 'red' }}>*</span> Email
                    </Typography>
                    <TextField
                        fullWidth
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        // placeholder="enter your email"
                        variant="outlined"
                        margin="dense"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <EmailIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Typography align="left" mt={2} mb={1} fontSize={14}>
                        <span style={{ color: 'red' }}>*</span> Password
                    </Typography>
                    <TextField
                        fullWidth
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        type={showPassword ? 'text' : 'password'}
                        variant="outlined"
                        margin="dense"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LockIcon />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword((prev) => !prev)}>
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Typography
                        variant="body2"
                        align="right"
                        onClick={()=>navigate("/forget-password")}
                        sx={{
                            mt: 1,
                            mb: 3,
                            cursor: 'pointer',
                            background: 'linear-gradient(to right, rgb(3,25,26), rgb(44,209,93))',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                        }}
                    >
                        Forget Password
                    </Typography>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={handleLogin}
                        disabled={isLoading} 
                        sx={{
                            background: 'linear-gradient(to right, #0f9ba1, #8ee3a8)',
                            color: 'white',
                            py: 1,
                            textTransform: 'none',
                            fontWeight: 600,
                            '&:hover': {
                                backgroundColor: '#1e5ae0',
                            },
                        }}
                    >
                        {isLoading ? (
                            <CircularProgress size={24} sx={{ color: "white" }} />
                        ) : (
                            "Go"
                        )}
                    </Button>

                </Paper>
            </Box>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbar.severity}
                    sx={{ width: "100%" }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
}
